import Vue from 'vue';
import { Fragment } from 'vue-fragment';

Vue.component('Fragment', Fragment);
